/**
 * PortalHook - Moves element content to a portal target to escape DOM nesting
 *
 * This is useful for modals that need to escape form nesting or z-index stacking contexts.
 * When an element with this hook mounts, it moves its content to the portal target div.
 * When it unmounts, LiveView will handle cleanup automatically.
 */
const PortalHook = {
  mounted() {
    // Get the portal target
    const portalTarget = document.querySelector("#modal-portal");

    if (portalTarget) {
      // Store original parent for potential cleanup
      this.originalParent = this.el.parentElement;
      this.originalNextSibling = this.el.nextSibling;

      // Move this element to the portal
      portalTarget.appendChild(this.el);
    }
  },

  destroyed() {
    // LiveView will handle DOM cleanup
    // If we need to move it back, we could do it here
    // but typically the element is being removed anyway
  }
};

export default PortalHook;
